import { ExperimentMap } from 'shared/experiments/interface'

export const PRODUCT_COLLECTIONS_EXPERIMENT_NAME = 'fy26_q1_collectionsinquickview'
export const NOTECARDS_PDP_FLOW_TEST_EXPERIMENT_NAME = 'note_cards_pdp_vs_dff'

export const experimentVariation: ExperimentMap = {
  [PRODUCT_COLLECTIONS_EXPERIMENT_NAME]: {
    Control: 'ProductCollectionsControl',
    Enabled1: 'ProductCollectionsEnabled1',
    Enabled2: 'ProductCollectionsEnabled2',
  },
  [NOTECARDS_PDP_FLOW_TEST_EXPERIMENT_NAME]: {
    Control: 'NoteCardsPDPFlowTestControl',
    Enabled: 'NoteCardsPDPFlowTestEnabled',
  },
}

export const galleryExperiments = Object.keys(experimentVariation)
